module.exports = __webpack_public_path__ + "static/media/entregarinjuseremi.c0b3315a.mp3";